import React from 'react'
import AppBar from './AppBar'
import PrivacyPolicyPage from '../pages/legal/PrivacyPolicyPage'
import TermsPage from '../pages/legal/TermsPage'
import LocationTermsPage from '../pages/legal/LocationTermsPage'
import MarketingConsentPage from '../pages/legal/MarketingConsentPage'

export type LegalDocType = 'terms' | 'location' | 'privacy' | 'marketing'

interface LegalDocViewerProps {
  /** null이면 닫힘 */
  type: LegalDocType | null
  onClose: () => void
}

const TITLE: Record<LegalDocType, string> = {
  terms: 'TASTEE 이용약관',
  location: '위치기반서비스 이용약관',
  privacy: '개인정보처리방침',
  marketing: '마케팅 정보 수신 동의',
}

const DOC: Record<LegalDocType, React.FC> = {
  terms: TermsPage,
  location: LocationTermsPage,
  privacy: PrivacyPolicyPage,
  marketing: MarketingConsentPage,
}

/**
 * 약관/방침을 앱 안에서(브라우저 이동 없이) 전체화면으로 보여주는 뷰어.
 * 상단 AppBar 뒤로가기로 닫으며, 뒤에 있던 가입 시트/상태는 그대로 유지된다.
 * 시트(z-1050) 위에 뜨도록 z-1060.
 */
const LegalDocViewer: React.FC<LegalDocViewerProps> = ({ type, onClose }) => {
  if (!type) return null
  const Doc = DOC[type]

  return (
    <div
      className="fixed inset-0 z-[1060] flex justify-center"
      style={{
        background: '#FAF6EF',
        // 전체화면 오버레이라 글로벌 상태바 보정(.app-swipe-root) 밖 → 노치/다이나믹아일랜드
        // 뒤로 안 깔리도록 safe-area 직접 보정 (iOS만 값 존재, 웹/안드는 0)
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="app-container h-full flex flex-col">
        <AppBar title={TITLE[type]} onBack={onClose} isBottomBorder />
        <div className="flex-1 overflow-y-auto scrollbar-hide">
          <Doc />
        </div>
      </div>
    </div>
  )
}

export default LegalDocViewer
